<template>
    <v-container>
        <v-card class="mood-assessment-window">
            <v-card-title >
                <div class="d-flex flex-column align-center w-100">
                    <v-btn icon size="small" class="align-self-end" @click="hideAssessment">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <div class="text-center mt-2">
                        <h4 style="white-space: normal;">{{prompt}}</h4>
                    </div>
                </div>
            </v-card-title>
            <div class="mood-assessment-selection-window">
                <button 
                    v-for="(option, index) in options"
                    :key="index"
                    :class="{
                        'default-option': selectedOption == null,
                        'large-option': selectedOption === index,
                        'opaque-option': selectedOption != null && selectedOption != index
                    }"
                    @click="selectOption(index)"
                    class="transition-all duration-300 ease-in-out p-2 m-2 bg-blue-500 text-white"
                >
                    {{ option.text }}
                </button>
            </div>
            <textarea v-model="assessmentNote" class="mood-assessment-notes" :placeholder="placeholder"></textarea>
            <div class="submit-container">
                <v-btn @click="submit" class="submit-button" size="large" color="#ff6d44">Submit</v-btn>
            </div>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios';

export default{
    name: 'AssessmentComponent',
    data(){
        return{
            selectedOption: null,
            moodOptions: [
                { text: "😭"},
                { text: "😞"},
                { text: "😕"},
                { text: "😐"},
                { text: "🙂"},
                { text: "😃"},
                { text: "🤩"},
            ],
            anxietyOptions: [
                { text: "😌"},
                { text: "😕"},
                { text: "😟"},
                { text: "😰"},
                { text: "😨"},
                { text: "😧"},
                { text: "😱"},
            ],
            options: [],
            prompt: "",
            moodPrompt: "What's your current mood? Select an emoji.",
            anxietyPrompt: "What's your current anxiety? Select an emoji",
            moodPlaceholder: "What happened today that influenced your mood?",
            anxietyPlaceholder: "What thoughts or situations contributed to your anxiety level?",
            placeholder: "",
            assessmentNote: "",
            moodAssessment: {
                patientId: "",
                moodRating: 0,
                moodNote: "",
                entryDate: ""
            },
            anxietyAssessment: {
                patientId: "",
                anxietyRating: 0,
                anxietyNote: "",
                entryDate: ""
            }
        }
    },  
    props: {
        isVisible: Boolean,
        assessmentType: String
    },
    methods: {
        hideAssessment(){
            this.$emit('update:isVisible', false)
        },
        selectOption(index){
            if(this.selectedOption == index) {
                this.selectedOption = null
            }else{
                this.selectedOption = index
            }
            console.log(this.selectedOption)
        },
        async submit(){
            if(this.selectedOption == null){
                alert("Please indicate your choice before submitting");
                return;
            }
            axios.defaults.baseURL = process.env.VUE_APP_API_URL;
            try{
                const patientId = localStorage.getItem("patientId");
                if(this.assessmentType.toLowerCase() == "mood"){
                    this.moodAssessment.moodRating = this.selectedOption + 1;
                    this.moodAssessment.patientId = "00000000-0000-0000-0000-000000000000";
                    this.moodAssessment.moodNote = this.assessmentNote;
                    this.moodAssessment.entryDate = this.getLocaleISODate();
                    await axios.post(`/api/patientmood/add-patient-mood/${patientId}`, this.moodAssessment);
                }else{
                    this.anxietyAssessment.anxietyRating = this.selectedOption + 1;
                    this.anxietyAssessment.patientId = "00000000-0000-0000-0000-000000000000";
                    this.anxietyAssessment.anxietyNote = this.assessmentNote;
                    this.anxietyAssessment.entryDate = this.getLocaleISODate();
                    await axios.post(`/api/patientanxiety/add-patient-anxiety/${patientId}`, this.anxietyAssessment);
                }
            }catch(error){
                console.log(error);
            }
            
            this.hideAssessment();
        },
        getLocaleISODate(){
            return new Date().toLocaleString('sv', {year:'numeric', month:'numeric', day:'numeric', hour:'numeric', minute:'numeric', second:'numeric', fractionalSecondDigits: 3}).replace(',', '.').replace(' ', 'T') + 'Z'
        }
    },
    mounted(){
        if(this.assessmentType.toLowerCase() == "mood"){
            this.options = this.moodOptions;
            this.prompt = this.moodPrompt;
            this.placeholder = this.moodPlaceholder;
        }else{
            this.options = this.anxietyOptions;
            this.prompt = this.anxietyPrompt;
            this.placeholder = this.anxietyPlaceholder;
        }
    }
}
</script>

<style>
    * {
        font-family: 'Montserrat', 'sans-serif';
    }

    .mood-assessment-window{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        border: 2px solid #08b6aa;
        background-color: white;
    }

    .mood-assessment-container{
        height: auto;
        width: 100%;
        display: flex;
        justify-content: center;
        align-content: center;
        flex-wrap: wrap;
    }
    
    .mood-assessment-selection-window{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 90%;
        margin-bottom: 3%;
    }

    .default-option{
        font-size: xx-large;
    }

    .large-option{
        font-size: xx-large;
        transform: scale(1.2);
    }

    .opaque-option{
        font-size: xx-large;
        opacity: 0.5;
    }

    .mood-assessment-text{
        font-family: 'Montserrat';
        text-align: center;
    }

    .mood-assessment-notes{
        width: 85%;
        height: 40%;
        border: 2px solid #ccc;
        background-color: #f8f8f8;
        border-radius: 4px;
        resize: none;
        padding: 10px;
        outline: none;
    }  

    .mood-assessment-notes:focus{
        border-color: #08b6aa;
    }

    .submit-container{
        display: flex;
        height: 20%;
        justify-content: center;
        align-content: center;
        flex-wrap: wrap;
        margin-top: 5%;
        margin-bottom: 5%;
    }

    .submit-button{
        background-color: #FF6D44;
        font-family: 'Montserrat';
        font-weight: bold;
    }

</style>